import api from './api';

/**
 * Grounded Privacy Assistant — GET /api/chatbot/context/, POST /api/chatbot/message/
 */
export async function fetchPrivacyAssistantContext() {
  const response = await api.get('/chatbot/context/');
  const data = response.data || {};
  return data.context_hint || null;
}

export async function sendPrivacyAssistantMessage(message, platform = null) {
  const payload = { message: String(message || '').trim() };
  if (platform) {
    payload.platform = platform;
  }
  const response = await api.post('/chatbot/message/', payload);
  const data = response.data || {};
  return {
    reply: data.reply || '',
    intent: data.intent || null,
    intentGroups: Array.isArray(data.intent_groups) ? data.intent_groups : [],
    suggestions: Array.isArray(data.suggestions) ? data.suggestions : [],
    explanation: data.explanation || null,
    why_it_matters: data.why_it_matters || null,
    urgency: data.urgency || null,
    steps: Array.isArray(data.steps) ? data.steps : null,
    responseMode: data.response_mode || null,
    contextHint: data.context_hint || null,
    conversationMode: data.conversation_mode || null,
    querySlots: data.query_slots || {},
    showUrgencyChip:
      data.show_urgency_chip === true ||
      (data.show_urgency_chip === undefined && !!data.urgency),
    showExplanation:
      data.show_explanation === true ||
      (data.show_explanation === undefined && !!data.explanation),
    showWhy:
      data.show_why === true || (data.show_why === undefined && !!data.why_it_matters),
    showSteps:
      data.show_steps === true ||
      (data.show_steps === undefined && Array.isArray(data.steps) && data.steps.length > 0),
    status: data.status,
    message: data.message,
  };
}

const privacyAssistantService = {
  sendPrivacyAssistantMessage,
  fetchPrivacyAssistantContext,
};
export default privacyAssistantService;
